import type { SolutionGasRsoCalculator } from "../../d";

export const solutionGasRsoCalculator: SolutionGasRsoCalculator = params => {
  const {
    gasSpecificGravity,
    oilAPI,
    surfaceTemperatureF,
    tubingPressurePSIA,
    inSituPressurePSIA,
    reservoirPressurePSIA,
    oilSpecificGravity,
    temperatureInRankine,
    temperatureF,
    gasOilRatio
  } = params;

  // D156: D8*(1+0.5912*D7*D6*LOG10(D5/114.7)*10^-4)
  let gasSGatSeparatorYgPsp = gasSpecificGravity;
  if (tubingPressurePSIA) {
    gasSGatSeparatorYgPsp =
      gasSpecificGravity *
      (1 +
        0.5912 *
          oilAPI *
          surfaceTemperatureF *
          Math.log10(tubingPressurePSIA / 114.7) *
          10 ** -4);
  }

  // D158: =0.01347*(D156^0.3873)*(D3^1.1715)*(10^((12.753*D7)/D15))
  const solutionGasRsoInSitu_gt_31 =
    0.01347 *
    gasSGatSeparatorYgPsp ** 0.3873 *
    inSituPressurePSIA ** 1.1715 *
    10 ** ((12.753 * oilAPI) / temperatureInRankine);
  // D160: =0.10084*(D156^0.2556)*(D3^0.9868)*(10^((7.4576*D7)/D15))
  const solutionGasRsoInSitu_22_31 =
    0.10084 *
    gasSGatSeparatorYgPsp ** 0.2556 *
    inSituPressurePSIA ** 0.9868 *
    10 ** ((7.4576 * oilAPI) / temperatureInRankine);

  // D162: =((D156*(D3^1.2057))/56.434)*(10^(10.9267*D17/D15))
  const solutionGasRsoInSitu_10_22 =
    ((gasSGatSeparatorYgPsp * inSituPressurePSIA ** 1.2057) / 56.434) *
    10 ** ((10.9267 * oilSpecificGravity) / temperatureInRankine);

  // D164: =D8*((D3/10.7025)*10^(0.0169*D17-0.00156*D4))^1.1128
  const solutionGasRsoInSitu_lt_10 =
    gasSpecificGravity *
    ((inSituPressurePSIA / 10.7025) *
      10 ** (0.0169 * oilSpecificGravity - 0.00156 * temperatureF)) **
      1.1128;

  // D166: IF(D7<=10,D145,IF(AND(D7>10,D7<=22.3),D143,IF(AND(D7<=31.1,D7>22.3),D141,D158)))
  let solutionGasRsoInSitu;
  if (oilAPI > 31.1) {
    solutionGasRsoInSitu = solutionGasRsoInSitu_gt_31;
  } else if (oilAPI > 22.3 && oilAPI <= 31.1) {
    solutionGasRsoInSitu = solutionGasRsoInSitu_22_31;
  } else if (oilAPI > 10 && oilAPI <= 22.3) {
    solutionGasRsoInSitu = solutionGasRsoInSitu_10_22;
  } else {
    solutionGasRsoInSitu = solutionGasRsoInSitu_lt_10;
  }

  // D168: =0.01347*(D156^0.3873)*(D12^1.1715)*(10^((12.753*D7)/D15))
  const solutionGasRsoAtReservoir_gt_31 =
    0.01347 *
    gasSGatSeparatorYgPsp ** 0.3873 *
    reservoirPressurePSIA ** 1.1715 *
    10 ** ((12.753 * oilAPI) / temperatureInRankine);
  // D170: =0.10084*(D156^0.2556)*(D12^0.9868)*(10^((7.4576*D7)/D15))
  const solutionGasRsoAtReservoir_22_31 =
    0.10084 *
    gasSGatSeparatorYgPsp ** 0.2556 *
    reservoirPressurePSIA ** 0.9868 *
    10 ** ((7.4576 * oilAPI) / temperatureInRankine);
  // D172: =((D156*(D12^1.2057))/56.434)*(10^(10.9267*D17/D15))
  const solutionGasRsoAtReservoir_10_22 =
    ((gasSGatSeparatorYgPsp * reservoirPressurePSIA ** 1.2057) / 56.434) *
    10 ** ((10.9267 * oilSpecificGravity) / temperatureInRankine);

  // D174: =D8*((D12/10.7025)*10^(0.0169*D17-0.00156*D4))^1.1128
  const solutionGasRsoAtReservoir_lt_10 =
    gasSpecificGravity *
    ((reservoirPressurePSIA / 10.7025) *
      10 ** (0.0169 * oilSpecificGravity - 0.00156 * temperatureF)) **
      1.1128;
  // D176: =IF(D7<=10,D174,IF(AND(D7>10,D7<=22.3),D172,IF(AND(D7<=31.1,D7>22.3),D170,D168)))
  let solutionGasRsoAtReservoir;
  if (oilAPI > 31.1) {
    solutionGasRsoAtReservoir = solutionGasRsoAtReservoir_gt_31;
  } else if (oilAPI > 22.3 && oilAPI <= 31.1) {
    solutionGasRsoAtReservoir = solutionGasRsoAtReservoir_22_31;
  } else if (oilAPI > 10 && oilAPI <= 22.3) {
    solutionGasRsoAtReservoir = solutionGasRsoAtReservoir_10_22;
  } else {
    solutionGasRsoAtReservoir = solutionGasRsoAtReservoir_lt_10;
  }

  return {
    gasSpecificGravity,
    oilAPI,
    surfaceTemperatureF,
    tubingPressurePSIA,
    inSituPressurePSIA,
    oilSpecificGravity,
    temperatureInRankine,
    temperatureF,
    gasOilRatio,
    solutionGasRsoAtReservoir_gt_31,
    solutionGasRsoAtReservoir_22_31,
    solutionGasRsoAtReservoir_10_22,
    solutionGasRsoAtReservoir_lt_10,
    solutionGasRsoAtReservoir:
      solutionGasRsoAtReservoir > gasOilRatio
        ? gasOilRatio
        : solutionGasRsoAtReservoir,
    solutionGasRsoInSitu:
      solutionGasRsoInSitu > gasOilRatio ? gasOilRatio : solutionGasRsoInSitu,
    gasSGatSeparatorYgPsp
  };
};
